module.exports = __webpack_public_path__ + "img/left-guide.d665eac3.svg";